module.exports = __webpack_public_path__ + "static/cg_role_260_00083b46c5a.wav";